import React from 'react';
import { ActionCodeOperation } from 'firebase/auth';

import EmailActionConfirmBase from './EmailActionConfirmBase';

function RecoverEmailConfirm(props) {
  return (
    <EmailActionConfirmBase
      {...props}
      actionOperation={ActionCodeOperation.RECOVER_EMAIL}
      title='Restore email address'
      checkingText='Checking this email recovery link...'
      applyingText='Restoring this email address...'
      successMessage='Your email address has been restored.'
      confirmLabel='Confirm'
      labels={{
        linkNoun: 'This email recovery link',
        actionNoun: 'Email recovery',
      }}
      buildReadyCopy={(info) => {
        const previousEmail =
          (info && info.data && info.data.previousEmail) || 'your previous email';
        const currentEmail =
          (info && info.data && info.data.email) || 'your current email';

        return (
          <>
            Restore the sign-in email from <strong>{currentEmail}</strong> back to <strong>{previousEmail}</strong>?
          </>
        );
      }}
      buildSuccessCopy={(info) => {
        const previousEmail =
          (info && info.data && info.data.previousEmail) || 'Your previous email address';

        return (
          <>
            <strong>{previousEmail}</strong> is active again for this account.
          </>
        );
      }}
      buildMismatchMessage={() => 'This link is not for restoring an email address.'}
    />
  );
}

export default RecoverEmailConfirm;
